import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { LicenseDataService } from '../../Services/LicenseDataService';
import LoadingScreen from '../LoadingScreen/LoadingScreen';

const LicenseProtectedRoute = () => {
    const { instance, accounts, inProgress } = useMsal();
    const [licenseStatus, setLicenseStatus] = useState(null); // null while loading

    useEffect(() => {
        const validateLicense = async () => {
            if (inProgress === "none" && accounts.length > 0) {
                try {
                    const request = { account: accounts[0] };
                    const response = await instance.acquireTokenSilent(request);
                    const result = await LicenseDataService.validateLicense(response.accessToken);
                    if(result && result.status == 200){
                        setLicenseStatus(result.data);
                    }
                    else {
                        console.error('Failed to validate license');
                        setLicenseStatus({ isLicenseActive: false, hasUserSlot: false }); // Treat as inactive if error occurs
                    }
                } catch (error) {
                    console.error('Failed to validate license', error);
                    setLicenseStatus({ isLicenseActive: false, hasUserSlot: false }); // Treat as inactive if error occurs
                }
            }
        };

            validateLicense();  
    }, [instance, accounts, inProgress]);

    if (licenseStatus === null) {
        return <LoadingScreen />;
        return <div>Loading...</div>; // Show loading state while validation is in progress
    }

    // Redirect based on license and slot status
    if (!licenseStatus.isLicenseActive) {
        return <Navigate to="/license" replace />;
    }
    if (!licenseStatus.hasUserSlot) {
        return <Navigate to="/no-seat-assigned" replace />;
    }

    return <Outlet />;
};

export default LicenseProtectedRoute;
